/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ROUTES } from "@/shared";

import { colors } from "@dotnet/telematics-design-system";

import TableHeadActions from "../../../actions/TableHeadActions/TableHeadActions";
import { useTableStyles } from "../../../styles/styles";
import TableHeadToolbar from "../../TableHeadToolbar/TableHeadToolbar";

interface DesktopTableHeadActiveProps {
  route: ROUTES;
}

const DesktopTableHeadActive = ({ route }: DesktopTableHeadActiveProps) => {
  const { blue100, blue200 } = colors;

  const { desktopTableHeadActive } = useTableStyles();

  return (
    <div
      data-testid="desktop-table-active-head"
      css={css([
        {
          background: blue100,
          borderTop: `1px solid ${blue200}`,
          borderBottom: `1px solid ${blue200}`
        },
        desktopTableHeadActive
      ])}
    >
      <TableHeadToolbar route={route}>
        <TableHeadActions route={route} />
      </TableHeadToolbar>
    </div>
  );
};

export default DesktopTableHeadActive;
